<template>
  <div>
    <vue-json-pretty
      :data="value"
      :deep="deep"
      :showIcon="true"
      :showDoubleQuotes="true"
      :showKeyValueSpace="true"
      :collapsedOnClickBrackets="true"
      :showLength="true" />
  </div>
</template>

<script>
  // eslint-disable-next-line import/no-extraneous-dependencies
  import VueJsonPretty from 'vue-json-pretty';
  // eslint-disable-next-line import/no-extraneous-dependencies
  import 'vue-json-pretty/lib/styles.css';

  export default {
    name: 'JsonPretty',
    components: {
      VueJsonPretty,
    },
    props: {
      value: {
        required: true,
      },
      deep: {
        required: false,
        type: Number,
        default: 1,
      },
    },
  };
</script>
